import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { Expand } from "../../components/cms/blocks/widgets/expandBlock.gen"
import { expandBlockClasses } from "../../components/public_site/blocks/style.mod"
import { StyleguideChapter, StyleguidePart, StyleguideSection } from "./helpers"
import { gridItem } from "./object/gridItem"

export const styleguideObjects: Widget<never> = mk_widget({
  run: _ => (
    <>
      {/* chapter*/}
      <section id="objects" className="styleguide-chapter styleguide-chapter--objects">
        <header className="styleguide--styled styleguide-chapter__header">
          <h2 className="styleguide__title styleguide-chapter__title">Design Objects</h2>
          <p className="styleguide-chapter__intro">If design tokens are the atoms of the design system, design objects are the material — specifically, they what comes after. We use them to make the developer’s job easier and to give the designers some extra insight in their work.</p>
        </header>

        <div className="styleguide-chapter__content">
          <section id="objects-links" className="styleguide-section styleguide-section--objects">

            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Links</h3>
              <p className="styleguide-section__intro">The links are clickable items to perform an action. They should be used in situations where user might need to submit a form, begin a task or specify a next or new step in a process.</p>
            </header>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Inline link</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">The default link used throughout the entire website.</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <div className="text--styled">
                        <p>Integer posuere erat a ante venenatis <a href="#">Donec ullamcorper nulla</a> aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.</p>
                      </div>
                    </div>
                  </section>
                </div>
              </section>
            </div>

          </section>
        </div>

        <div className="styleguide-chapter__content">
          {/* section*/}
          <section id="objects-buttons" className="styleguide-section styleguide-section--objects">

            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Buttons</h3>
              {/* <p className="styleguide-section__intro">The links are clickable items to perform an action. They should be used in situations where user might need to submit a form, begin a task or specify a next or new step in a process.</p> */}
            </header>

            <div className="styleguide-section__content">
              {/* part */}
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Button primary</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">The primary button.</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <button className="btn btn--primary">
                        <span className="btn__text">Primary Button</span>
                      </button>
                    </div>
                  </section>
                </div>
              </section>
            </div>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Button secondary</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">The secondary button. Hover: I used the same logic as the download / expad block</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <button className="btn btn--secondary">
                        <span className="btn__text">Secondary Button</span>
                      </button>
                    </div>
                  </section>
                </div>
              </section>
            </div>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Button tertiary</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">The tertiary button. Hover: I used the same logic as the download / expad block</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <button className="btn btn--tertiary">
                        <span className="btn__text">Tertiary Button</span>
                      </button>
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </section>
        </div>

        <div className="styleguide-chapter__content">
          <section id="objects-lists" className="styleguide-section styleguide-section--objects">

            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Lists</h3>
            </header>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Unordered list (default)</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">This is how a default unordered list looks when generated from a WISYWIG.</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <div className="text--styled">
                        <ul>
                          <li>Text without anchor</li>
                          <li><a href="#">Text with anchor</a></li>
                          <li>Tristique Nibh Fringilla</li>
                          <li>Vestibulum id ligula porta felis euismod semper.</li>
                          <li>Donec ullamcorper nulla non metus auctor fringilla.</li>
                        </ul>
                      </div>
                    </div>
                  </section>
                </div>
              </section>
            </div>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Ordered list (default)</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">This is how a default ordered list looks when generated from a WISYWIG.</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <div className="text--styled">
                        <ol>
                          <li>Text without anchor</li>
                          <li><a href="#">Text with anchor</a></li>
                          <li>Tristique Nibh Fringilla</li>
                          <li>Vestibulum id ligula porta felis euismod semper.</li>
                          <li>Donec ullamcorper nulla non metus auctor fringilla.</li>
                        </ol>
                      </div>
                    </div>
                  </section>
                </div>
              </section>
            </div>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">List with chevron</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">These are the lists in the Footer and Main navigation menus.</p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>
                    <div className="styleguide-example__section cf">
                      <ul className="list--chevron">
                        <li className="list__item">
                          <svg
                            className="list__icon"
                            width="8px"
                            height="5px"
                          >
                            <use xlinkHref="#icon--chevron" />
                          </svg>
                          <span>Text without anchor</span>
                        </li>
                        <li className="list__item">
                          <a className="list__link" href="#">
                            <svg
                              className="list__icon"
                              width="8px"
                              height="5px"
                            >
                              <use xlinkHref="#icon--chevron" />
                            </svg>
                            <span>Text with anchor</span>
                          </a>
                        </li>
                        <li className="list__item">
                          <svg
                            className="list__icon"
                            width="8px"
                            height="5px"
                          >
                            <use xlinkHref="#icon--chevron" />
                          </svg>
                          <span>Vestibulum id ligula porta felis euismod semper.</span>
                        </li>
                        <li className="list__item">
                          <svg
                            className="list__icon"
                            width="8px"
                            height="5px"
                          >
                            <use xlinkHref="#icon--chevron" />
                          </svg>
                          <span>Donec ullamcorper nulla non metus auctor fringilla.</span>
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>
              </section>
            </div>
            
          </section>
        </div>

        {StyleguideChapter({title: ''})(
          any()([
            StyleguideSection({title: 'Grid Item', slug: 'objects-grid'})(
              any()([
                StyleguidePart({title: 'Without image'})(
                  mk_widget({
                    run: _ => (
                      <ul className="container container--l c--columns">
                        {gridItem({hasLink: true, inner: {hasLink: true, hasImage: false, hasIntro: false}})}
                        {gridItem({hasLink: true, inner: {hasLink: true, hasImage: false, hasIntro: true}})}
                        {gridItem({hasLink: false, inner: {hasLink: false, hasImage: false, hasIntro: true}})}
                      </ul>
                    )
                  })
                ),
                StyleguidePart({title: 'With image'})(
                  mk_widget({
                    run: _ => (
                      <ul className="container container--l c--columns">
                        {gridItem({hasLink: true, hasImage: true, inner: {hasLink: true, hasImage: true, hasDate: false}})}
                        {gridItem({hasLink: false, hasImage: true, inner: {hasLink: false, hasImage: true, hasIntro: true}})}
                        {gridItem({hasLink: true, hasImage: true, inner: {hasLink: true, hasImage: true, hasDate: true}})}
                        {gridItem({hasLink: false, hasImage: true, inner: {hasLink: false, hasImage: true, hasDate: true}})}
                      </ul>
                    )
                  })
                )
              ])
            ),
            StyleguideSection({title: 'Expand items', slug: 'objects-expand'})(
              StyleguidePart({title: ''})(
                mk_widget({
                  run: _ => (
                    <ul className="expand__list">
                      {Expand({ title: "Magna Adipiscing Ullamcorper Purus", blocks: [{ blockKind: 'vidda/text', innerText: "Hello World" }], open: false }, { style: expandBlockClasses }).run((_) => { })}
                      {Expand({
                        title: "Magna Adipiscing Ullamcorper Purus",
                        blocks: [{ blockKind: 'vidda/text', innerText: "Hello World" }],
                        open: true
                      }, {style: expandBlockClasses}).run((_) => {})}
                    </ul>
                  )
                })
              )
            )
          ])
        ).run(_)}

        {StyleguideChapter({title: ''})(
          any()([
            StyleguideSection({title: 'Loader', slug: 'object-loader'})(
              any()([
                StyleguidePart({title: 'Loader'})(
                  mk_widget({
                    run: _ => (
                      <div className="loader loader--block">
                        <svg className="loader__icon" width="40px" height="40px">
                          <use xlinkHref="#icon--loader" />
                          <span className="sr-only">Loading...</span>
                        </svg>
                      </div>
                    )
                  })
                ),
              ])
            ),
            StyleguideSection({title: 'Loader Page', slug: 'object-loader'})(
              any()([
                StyleguidePart({title: 'Loader'})(
                  mk_widget({
                    run: _ => (
                      <div className="loader loader--page">
                        <div className="loader__inner">
                          <svg className="loader__icon" width="40px" height="40px" aria-hidden="true">
                            <use xlinkHref="#icon--loader" />
                            <span className="sr-only">Loading...</span>
                          </svg>
                        </div>
                      </div> 
                    )
                  })
                ),
              ])
            ),
          ])
        ).run(_)} 
      </section>
    </>
  )
})



// WEBPACK FOOTER //
// ./Client/styleguide/components/objects.tsx